<template>
  <form-item-facade
    class="data-picker-item"
    :errors="errors"  
    :name="name"
    :rules="rules"
  >
    <date-picker-facade
      v-model="model"
      :placeholder="placeholder"
      :disabled="disabled"
    >
      <template #suffixIcon>
        <slot name="suffixIcon"></slot>
      </template>
    </date-picker-facade>
  </form-item-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import DatePickerFacade from '@/lib/ant-design-vue/components/DatePickerFacade.vue';
  import FormItemFacade from '@/lib/ant-design-vue/components/FormItemFacade.vue';
  
  const model = defineModel();

  defineProps({
    // HTML-поле "name" для элемента формы.
    name: {
      type: [Array, String],
      required: true,
    },

    // Отключено ли поле ввода даты
    disabled: {
      type: Boolean,
      default: false,
    },

    // Объект, обрабатывающий ошибки.
    errors: Object,

    // Текст подсказки, что нужно ввести в поле
    placeholder: {
      type: String,
      default: '',
    },

    // Правила валидации поля.
    rules: Object,
  });
</script>

<style lang="scss" scoped>

</style>